import React from 'react';
import FormLabel from '../label';
import { INPUT_TYPE_NUMBER, INPUT_TYPE_INTEGER } from '../../../app-constants';

const numberOnKeyDown = event => (event.key === 'e' || event.key === '-') && event.preventDefault();

const numberOnPaste = (event) => {
  const invalidQuantityCharacters = /e|-/gi;
  if (event.clipboardData.getData('Text').match(invalidQuantityCharacters)) {
    event.preventDefault();
  }
};

const integerOnKeyDown = event => (
  event.key !== '1' &&
  event.key !== '2' &&
  event.key !== '3' &&
  event.key !== '4' &&
  event.key !== '5' &&
  event.key !== '6' &&
  event.key !== '7' &&
  event.key !== '8' &&
  event.key !== '9' &&
  event.key !== '0' &&
  event.key !== 'Backspace')
   && event.preventDefault();

const integerOnPaste = (event) => {
  const invalidQuantityCharacters = /e|-|\./gi;
  if (event.clipboardData.getData('Text').match(invalidQuantityCharacters)) {
    event.preventDefault();
  }
};

const TextField = (props) => {
  const { label, id, placeholder, onBlur, onChange, disabled = false, value, type = 'text' } = props;
  // Use the numberOnKeyDown defined above, only if the input is of type number and deos not pass in a onKeyDown function.
  let onKeyDown;
  let onPaste;

  switch (props.type) {
    case INPUT_TYPE_NUMBER:
      onKeyDown = props.onKeyDown || numberOnKeyDown;
      onPaste = numberOnPaste;
      break;
    case INPUT_TYPE_INTEGER:
      onKeyDown = props.onKeyDown || integerOnKeyDown;
      onPaste = integerOnPaste;
      break;
    default :
      onKeyDown = props.onKeyDown;
      onPaste = null;
      break;
  }

  return (
    <div className="text-field text-left">
      {label && (
        <FormLabel
          label={label}
          forId={id}
        />
      )}
      <input
        type={type === INPUT_TYPE_INTEGER ? INPUT_TYPE_NUMBER : type}
        id={id}
        name={id}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        onPaste={onPaste}
        disabled={disabled}
      />
    </div>
  );
};

export default TextField;
